/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useFormatValue} from "../../../../Hooks/FormatterHooks";

export const ColumnCell = (props) => {
    
    const columnData = props.column.columnDef.data;
    const columnFormatter = useFormatValue(columnData?.formatter?.name, columnData?.formatter?.params);
    
    if (props.getValue() === null) {
        return <span className="stale">NULL</span>;
    }
    
    let value = props.getValue();
    
    if (columnData?.sbOptions) {
        value = columnData.sbOptions?.[value] ?? value;
    }
    
    switch (columnData?.dataType) {
        case 'int':
            if (columnData?.shortName?.endsWith?.('Id')) {
                break;
            }
        // falls through
        case 'float':
            if (value != null) {
                value = isNaN(value) ? value : columnFormatter(value);
            }
            break;
        case 'bool':
            value = Number(value) ? 'Yes' : 'No';
            break;
        default:
            value = value;
    }
    
    return columnData?.suffix ? `${value} ${columnData.suffix}` : value || null;
};
